import React, { useRef } from 'react'
import styles from './giftCardFilterField.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'
import { CloseButton } from 'src/chrome'
import { useEffect } from 'src/hooks'

type GiftCardFilterFieldProps = {
  label: string
  value: string
  placeholder?: string
  onRemove: () => void
  onChange: (value: string) => void
  inputStyles?: React.CSSProperties
}

const GiftCardFilterField: React.FC<GiftCardFilterFieldProps> = props => {
  const { label, value, placeholder, onChange, onRemove, inputStyles } = props

  const inputRef = useRef<HTMLInputElement>(null)

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  // Using keyDown, because keyUp will trigger after other things happened (update searchData)
  // causing the backspace to remove the element before it should
  const handleKeyDown = (e: React.KeyboardEvent) => {
    const { key } = e

    switch (key) {
      case 'Backspace':
        if (value === '') {
          onRemove()
        }
        break

      case 'Enter':
        if (value !== '') {
          onChange(value)
        }
        break
    }
  }

  const handleOnFocus = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    inputRef.current?.focus()
  }

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <div className={styles.wrapper} onClick={handleOnFocus}>
      <div>
        <Text type="caption" weight="semiBold" content={`${label}:`} />
      </div>
      <input
        ref={inputRef}
        value={value}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder ?? undefined}
        style={{
          border: 'none',
          backgroundColor: 'transparent',
          fontFamily: 'Montserrat',
          margin: '0 0.75rem',
          ...inputStyles,
        }}
      />
      <CloseButton onClose={onRemove} size={18} />
    </div>
  )
}

export default GiftCardFilterField
